import React from 'react'
import { Link } from 'gatsby'
import { ColorToHex } from '../../utility.js'
import Icon from '../icon/icon.js'
import * as styles from './button.module.css'

export default ({
  text,
  size,
  url = '',
  target = '',
  link,
  color = 'Tangerine',
  icon,
  isInverse = false,
  hasBorder = false,
  onClick,
  onClick2,
}) => {
  // COLOR
  let style
  if (isInverse) {
    style = {
      color: ColorToHex(color),
      backgroundColor: 'white',
    }
  } else {
    if (hasBorder) {
      style = {
        color: 'white',
        backgroundColor: ColorToHex(color),
        border: '2px solid white',
        lineHeight: '1.9'
      }
    } else {
      style = {
        color: 'white',
        backgroundColor: ColorToHex(color)
      }
    }
  }

  // ICON
  let iconEl = null
  if (icon) {
    iconEl = (
      <Icon
        icon={icon}
        height="18"
        color={isInverse ? color : 'white'}
        className="ml-2"
      />
    )
  }

  function handleClick(ev) {
    if (onClick) {
      ev.preventDefault()
      onClick()
    }
  }

  let classes
  switch (size) {
    case 'small':
      classes = `${styles.button} ${styles.buttonSmall}`
      break
    case 'smallLongText':
      classes = `${styles.button} ${styles.buttonSmall} ${styles.buttonSmallLongText}`
      break
    case 'large':
      classes = `${styles.button} ${styles.buttonLarge}`
      break
    case 'medium':
      classes = `${styles.button} ${styles.buttonMedium}`
      break
    case 'flex':
      classes = `${styles.button} ${styles.buttonFlex}`
      break
    default:
      classes = `${styles.button}`
  }
  let buttonInner = (
    <span className={styles.buttonInner}>
      {text} {iconEl}
    </span>
  )

  if (link && typeof link === 'object') {
    console.log('LINK', text, link)
    if (link.document && Object.keys(link.document).length > 0) {
      return (
        <a href={link.document.uid} className={classes} style={style} target={target}>
          {buttonInner}
        </a>
      )
    } else if (!link.document || link.link_type === 'Document') {
      /* console.log('DOC LINK --->>', text, link) */
      return (
        <a
          href={link.url}
          target={target}
          className={classes}
          style={style}
          onClick={(ev) => (onClick2 ? onClick2(ev) : null)}
        >
          {buttonInner}
        </a>
      )
    } else {
      return <button type="button">{text}</button>
    }
  } else if (link && typeof link === 'string') {
    if (url.match(/^http/)) {
      return (
        <a href={link} className={classes} style={style} target="_blank">
          {buttonInner}
        </a>
      )
    } else {
      return (
        <Link to={link} className={classes} style={style}>
          {buttonInner}
        </Link>
      )
    }
  } else if (typeof onClick === 'function') {
    return (
      <button className={classes} style={style} onClick={handleClick}>
        {buttonInner}
      </button>
    )
  } else if (typeof url === 'string') {
    /* console.log('URL', text, url) */
    if (url.match(/^http/)) {
      return (
        <a href={url} className={classes} style={style} target="_blank">
          {buttonInner}
        </a>
      )
    } else {
      return (
        <Link to={url} className={classes} style={style}>
          {buttonInner}
        </Link>
      )
    }
  } else
    return (
      <button type="button" className={classes} style={style}>
        {buttonInner}
      </button>
    )
}
